import z from "zod";

import {
  FIELD_LABEL_ALIGNS,
  FIELD_ORIENTATIONS,
} from "@frontend/components/atoms/Field";
import { SIZES } from "@frontend/styles/constants";

import {
  FIELDSET_GAPS,
  FIELDSET_LEGEND_ALIGNS,
  FIELDSET_VARIANTS,
  FIELDSET_WIDTHS,
} from "./constants";

const booleanAttribute = z
  .string()
  .optional()
  .transform((value) => value !== undefined && value !== "false");

const booleanAttributeDefaultTrue = z
  .string()
  .optional()
  .transform((value) => value === undefined || value !== "false");

export const fieldsetDataSchema = z.object({
  legend: z.string().optional(),
  legendIcon: z
    .string()
    .optional()
    .describe("Optional Lucide icon name shown inside the legend."),
  legendAlign: z.enum(FIELDSET_LEGEND_ALIGNS).optional(),
  variant: z.enum(FIELDSET_VARIANTS).optional(),
  gap: z.enum(FIELDSET_GAPS).optional(),
  orientation: z.enum(FIELD_ORIENTATIONS).optional(),
  size: z.enum(SIZES).optional(),
  width: z.enum(FIELDSET_WIDTHS).optional(),
  labelAlign: z.enum(FIELD_LABEL_ALIGNS).optional(),
  collapsible: booleanAttribute,
  defaultOpen: booleanAttributeDefaultTrue,
  disabled: booleanAttribute,
});

export type FieldsetDataProps = z.infer<typeof fieldsetDataSchema>;
